import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

export default function Footer() {
  const { t, path } = useI18n();
  const cols = [
    {
      title: t.footer.platform,
      links: [
        { href: path("clinic"), label: t.nav.clinic },
        { href: path("employees"), label: t.nav.employees },
        { href: path("how"), label: t.nav.how },
      ],
    },
    {
      title: t.footer.company,
      links: [
        { href: path("contact"), label: t.nav.contact },
        { href: path("home"), label: t.footer.about },
      ],
    },
    {
      title: t.footer.legal,
      links: [
        { href: path("home"), label: t.footer.terms },
        { href: path("home"), label: t.footer.privacy },
        { href: path("contact"), label: t.nav.contact },
      ],
    },
  ];

  return (
    <footer className="border-t border-border bg-background">
      <div className="mx-auto max-w-container px-6 lg:px-10 py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Link to={path("home")} className="font-serif text-2xl text-foreground">
              Medessa
            </Link>
            <p className="mt-4 text-sm text-muted-foreground max-w-xs leading-relaxed">
              {t.footer.tagline}
            </p>
            <p className="mt-8 text-xs text-muted-foreground">{t.footer.location}</p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-3 gap-8">
            {cols.map((c) => (
              <div key={c.title}>
                <div className="text-xs uppercase tracking-[0.16em] text-muted-foreground mb-5">
                  {c.title}
                </div>
                <ul className="space-y-3">
                  {c.links.map((l) => (
                    <li key={`${c.title}-${l.label}`}>
                      <Link
                        to={l.href}
                        className="text-sm text-foreground hover:text-muted-foreground transition-colors"
                      >
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-border flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground">{t.footer.rights}</p>
          <p className="text-xs text-muted-foreground">kontakt@medessa.pl</p>
        </div>
      </div>
    </footer>
  );
}
